import { useAppSelector, useAppDispatch } from '../hooks/redux'
import { logout } from '../store/slices/authSlice'
import { ChevronDownIcon, UserCircleIcon, Bars3Icon } from '@heroicons/react/24/outline'
import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { useSystemSettings } from '../hooks/useSystemSettings'

interface HeaderProps {
  onMenuClick: () => void
}

const Header = ({ onMenuClick }: HeaderProps) => {
  const { user } = useAppSelector(state => state.auth)
  const dispatch = useAppDispatch()
  const { getSetting } = useSystemSettings()

  const handleLogout = () => {
    dispatch(logout())
  }

  const systemTitle = getSetting('system.title', 'MoniJira')
  const systemLogo = getSetting('system.logo', '')

  return (
    <header className="bg-white border-b border-gray-200 px-3 md:px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <button
            className="md:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
            onClick={onMenuClick}
          >
            <Bars3Icon className="h-6 w-6" />
          </button>
          <div className="flex items-center space-x-3">
            {systemLogo && (
              <img 
                src={systemLogo.startsWith('http') ? systemLogo : `${window.location.origin}${systemLogo}`}
                alt="系統 Logo" 
                className="h-8 w-auto object-contain"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none'
                }}
              />
            )}
            <h1 className="text-xl font-semibold text-gray-900">{systemTitle}</h1>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <Menu as="div" className="relative">
            <Menu.Button className="flex items-center space-x-2 text-sm text-gray-700 hover:text-gray-900">
              {user?.avatar ? (
                <img
                  src={user.avatar}
                  alt={user.name}
                  className="w-8 h-8 rounded-full"
                />
              ) : (
                <UserCircleIcon className="w-8 h-8 text-gray-400" />
              )}
              <span className="font-medium">{user?.name}</span>
              <ChevronDownIcon className="w-4 h-4" />
            </Menu.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 focus:outline-none">
                <div className="py-1">
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to="/profile"
                        className={`${
                          active ? 'bg-gray-50' : ''
                        } block px-4 py-2 text-sm text-gray-700`}
                      >
                        個人設定
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        onClick={handleLogout}
                        className={`${
                          active ? 'bg-gray-50' : ''
                        } block w-full text-left px-4 py-2 text-sm text-gray-700`}
                      >
                        登出
                      </button>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>
    </header>
  )
}

export default Header